import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="bg-[#FFF8E7] min-h-[70vh] flex items-center justify-center px-4" data-testid="page-payment-cancel">
      <div className="max-w-lg w-full bg-white border-2 border-[#0A0A0A] pop-shadow p-10 text-center">
        <span className="inline-flex w-16 h-16 bg-[#FFD93D] text-[#0A0A0A] items-center justify-center border-2 border-[#0A0A0A]">
          <XCircle className="w-8 h-8" />
        </span>
        <h1 className="font-heading font-black text-3xl text-[#0A0A0A] mt-6">Checkout cancelled</h1>
        <p className="text-[#2C2C2C] mt-3 leading-relaxed">
          No payment was taken. Whenever you&apos;re ready, membership and donations are waiting — no pressure.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/membership" data-testid="cancel-retry-link" className="bg-[#FF2E63] text-[#FFF8E7] hover:bg-[#E0204F] border-2 border-[#0A0A0A] px-6 py-3 text-sm font-medium">Back to Support us</Link>
          <Link to="/" data-testid="cancel-home-link" className="bg-[#FFD93D] text-[#0A0A0A] hover:bg-[#FFCB05] border-2 border-[#0A0A0A] px-6 py-3 text-sm font-medium">Go home</Link>
        </div>
      </div>
    </div>
  );
}
